<template>
  <div class="sticky-bottom-mobile">
    <!-- DESKTOP -->
    <div class="flex xs-hide flex-wrap justify-center items-start total-bar pb2">
      <div class="flex col-12 full-height dark-blue-bg white border-white">
        <div class="flex col-9 items-center">
          <span class="flex col-3 py2 pl3 h3">Total</span>
          <div class="flex flex-column justify-center items-end col-9 pr2">
            <div class="right-align">
              <span class="h5">à payer aujourd'hui </span>
              <span :class="['h5', {'crossed': hasPromo}]">{{ subscriptionPayment.firstPayment }}€</span>
              <span v-if="hasPromo" class="h5"> {{ subscriptionPayment.promo.firstPaymentPromo }}€</span>
            </div>
            <div v-if="!hasPromo" class="right-align">
              <span class="h5">puis </span>
              <span :class="['h5', {'crossed': hasRecurringPromo}]">{{ subscriptionPayment.recurringPayment }}€</span>
              <span v-if="hasRecurringPromo" class="h5"> {{ subscriptionPayment.promo.recurringPaymentPromo }}€ </span>
              <span class="h5"> /mois</span>
            </div>
          </div>
        </div>
        <span id="continue-button" class="flex col-3 p1 justify-center items-center caps h5 pointer red-bg border-left center " :class="[{disabled: !canAdvance}]" @click="confirmFunction()">{{ confirmLabel }}</span>
      </div>
    </div>
    <!-- MOBILE -->
    <div class="flex flex-wrap col-12-vw lg-hide md-hide sm-hide justify-center items-start dark-blue-bg white total-bar footer-margin px2 border-top-grey border-2 z5">
      <div class="flex col-2 p1">
        <span class="h5 bolder" style="margin-top: 4px;">Total</span>
      </div>
      <div class="flex flex-column items-end col-10 justify-between full-height p1">
        <div class="flex flex-column col-12">
          <div class="right-align">
            <span :class="['h5', {'h6 bolder': hasPromo}]">à payer aujourd'hui </span>
            <span :class="['h5', {'bolder crossed h6': hasPromo}]">{{ subscriptionPayment.firstPayment }}€</span>
            <span v-if="hasPromo" class="h6 bolder"> {{ subscriptionPayment.promo.firstPaymentPromo }}€</span>
          </div>
          <div v-if="!hasPromo" class="right-align">
            <span :class="['h5', {'h6 bolder': hasRecurringPromo}]">puis </span>
            <span :class="['h5', {'h6 bolder crossed': hasRecurringPromo}]"> {{ subscriptionPayment.recurringPayment }}€</span>
            <span v-if="hasRecurringPromo" class="h6 bolder"> {{ subscriptionPayment.promo.recurringPaymentPromo }}€</span>
            <span :class="['h5', {'h6 bolder': hasRecurringPromo}]">/mois</span>
          </div>
        </div>
        <div class="flex col-12 justify-end">
          <span id="continue-button-mobile" class="px3 red-bg caps h6 pointer confirm-button" :class="[{disabled: !canAdvance}]" @click="confirmFunction()">{{ confirmLabel }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { subscriptionPaymentInfo } from '@/utils/logics';

export default {
  props: {
    confirmFunction: {
      type: Function,
      default: () => {}
    },
    canAdvance: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    confirmLabel () {
      if (this.$route.name === 'NewTDACartRecapRecurring') {
        return this.isImpersonateMode ? 'Envoyer le lien de paiement' : 'Valider et payer';
      }
      return 'Continuer';
    },
    subscriptionPayment () {
      return subscriptionPaymentInfo(this.promoAmount, this.promoAmountFee, this.promoMetric);
    },
    hasPromo () {
      return this.subscriptionPayment.hasPromo;
    },
    promoAmount () {
      return this.$store.state.promoAmount;
    },
    promoAmountFee () {
      return this.$store.state.promoAmountFee;
    },
    promoMetric () {
      return this.$store.state.promoMetric;
    },
    isImpersonateMode () {
      return this.$store.getters.isImpersonateMode;
    },
    hasRecurringPromo () {
      return this.subscriptionPayment.hasRecurringPromo;
    }
  }
};

</script>

<style lang="scss" scoped>

@media (min-width: 40em) {
  .total-bar {
    height: 72px;
  }
}

.confirm-button{
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
}

.total-bar {
  min-height: 110px;
  height: 110px;
}
.col-12-vw{
  width: 100vw;
}
.footer-margin{
  margin: 0 -1rem;
}

.border-left {
  border-left: 1px solid white;
}

.price-text {
  font-size: 1.05rem;
}
</style>
